import { SOCIAL_CALLBACK, GET_PROFILE_DATA } from "constants/api";
import axios, { AxiosError } from "axios";
import FormPhone from "components/form-phone";
import { LoaderContext } from "contexts/loader-context";
import { useSession } from "contexts/session-context";
import useRouter from "hooks/use-router";
import { useContext } from "react";
import ProfileService from "services/profile-services";
import CONFIGS from 'build/Config'

function ProfilePhoneUpdate({ sumasix = false, toggleOtpSS, linkAccountSS }: { sumasix?: boolean, toggleOtpSS?: () => void, linkAccountSS?: (value: boolean) => void; }) {

  const [{ user, data: session }, { setUser }] = useSession()
  const { setLoad } = useContext(LoaderContext)
  const { push } = useRouter()

  const onSubmit = async (data, setError) => {
    setLoad(true)
    try {
      const response = (!CONFIGS?.profile?.phone?.useDirectPhone ? await ProfileService.otpVerifyPhone({ code: data.otp, session }) : await ProfileService.updatePhone({ phoneNumber: data.phoneNumber, session }))

      if (response?.status === 200) {
        setUser(response.data)

        if (!sumasix) {
          push('/profile/phone')
          return
        }

        await axios.put(`${SOCIAL_CALLBACK}sumasix/link?code=${response.data?.phoneNumber}`, {},
          { headers: { Authorization: `Bearer ${((session as any)?._tokenResponse as any)?.idToken}`, 'Ph-Api-Id': PH_API_ID ?? 1 } }
        )

        if (response.status === 200) {
          const responseProfile = await axios.get(`${GET_PROFILE_DATA}`,
            { headers: { Authorization: `Bearer ${((session as any)?._tokenResponse as any)?.idToken}`, 'Ph-Api-Id': PH_API_ID ?? 1 } }
          )

          setUser(responseProfile.data)
          linkAccountSS(true)
        }

      }
    } catch (err) {
      const typedError = err as AxiosError
      const { code } = typedError.response?.data || {}
      setError(code)
    } finally {
      setLoad(false)
    }
  }

  return (
    <div className={`mt-7 flex flex-col w-full ${sumasix ? 'h-full' : ''}`}>
      <FormPhone sumasix={sumasix} handleSubmit={onSubmit} user={user} toggleOtpSS={toggleOtpSS} />
    </div>
  );
}

export default ProfilePhoneUpdate;